<div class="premium-page">

  <!-- ==================== HERO ==================== -->
  <section class="hero">
    <div class="shell hero-inner">
      <div class="hero-left">
        <div class="ls-eyebrow">
          <span class="badge">Premium</span>
          <span>Pour les fidèles, les chorales et les paroisses</span>
        </div>
        <h1>Toute la louange,<br/><span class="accent">sans interruption.</span></h1>
        <p class="lede">Téléchargements hors-ligne, qualité studio, projection HD pour ton église — et pas une seule publicité. Premium soutient aussi la communauté qui maintient les paroles et les traductions à jour.</p>
        <div class="cta-row">
          <a class="btn btn-primary" href="/auth/register?plan=premium">Choisir un plan</a>
          <a class="btn btn-ghost" href="#compare">Comparer en détail</a>
        </div>
        <div class="reassure">
          <span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            14 jours gratuits
          </span>
          <span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Annulation à tout moment
          </span>
          <span>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            Paiement local · MonCash, Visa, Apple Pay
          </span>
        </div>
      </div>

      <div class="hero-vis" aria-hidden="true">
        <div class="hero-vis-bg"></div>
        <div class="hero-vis-content">
          <div class="top">
            <span class="dot"></span>
            <span>En écoute · hors-ligne · FLAC</span>
          </div>
          <div class="ti">Mèsi Senyè</div>
          <div class="by">Marie-Jean Florvil · Mélodies Joyeuses 87</div>
          <div class="lyric">
            Mèsi Senyè, mèsi Senyè<br/>
            <span class="now">Pou tout sa Ou fè pou mwen</span><br/>
            Lè m gade tout chemen an
          </div>
          <div class="features">
            <div class="feat-it">
              <span class="pill">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </span>
              Téléchargé · pas de réseau
            </div>
            <div class="feat-it">
              <span class="pill">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </span>
              Master FLAC sans perte
            </div>
            <div class="feat-it">
              <span class="pill">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </span>
              Projection HD prête
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ==================== WHY ==================== -->
  <section class="why">
    <div class="shell">
      <div class="section-eyebrow">Pourquoi Premium</div>
      <h2 class="section-h">Trois bonnes raisons<br/>de soutenir.</h2>
      <p class="section-lede">LyricStream reste gratuit pour tout le monde — c'est une promesse. Premium, c'est ce qui finance les serveurs, les modérateurs, les traductions… et toi, tu reçois en retour des outils sérieux.</p>

      <div class="why-grid">
        @for (reason of whyReasons; track reason.num) {
          <div class="why-card">
            <div class="num">{{ reason.num }}</div>
            <h3>{{ reason.title }}</h3>
            <p>{{ reason.desc }}</p>
            <div class="footnote">
              <span class="ic">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
              </span>
              {{ reason.footnote }}
            </div>
          </div>
        }
      </div>
    </div>
  </section>

  <!-- ==================== PRICING ==================== -->
  <section class="pricing" id="plans">
    <div class="shell">
      <div class="section-eyebrow">Plans</div>
      <h2 class="section-h">Choisis ton rythme.</h2>
      <p class="section-lede">Trois plans. Aucun engagement. Tu peux passer de l'un à l'autre, ou revenir au gratuit, à tout moment.</p>

      <div class="billing-toggle" role="tablist" aria-label="Période de facturation">
        <button class="toggle-btn" [class.on]="billingPeriod() === 'month'" type="button" (click)="billingPeriod.set('month')">Mensuel</button>
        <button class="toggle-btn" [class.on]="billingPeriod() === 'year'" type="button" (click)="billingPeriod.set('year')">Annuel <span class="save">−17%</span></button>
      </div>

      <div class="plans">

        <!-- GRATUIT -->
        <div class="plan">
          <div class="plan-tier">Plan</div>
          <div class="plan-name">Gratuit</div>
          <div class="plan-tagline">Pour explorer — toute la bibliothèque, sans engagement.</div>
          <div class="plan-price">
            <span class="cur">$</span>
            <span class="amt">0</span>
            <span class="per">/ pour toujours</span>
          </div>
          <div class="plan-price-sub">Avec annonces · qualité haute max</div>
          <a class="btn btn-ghost plan-btn" href="/auth/register">Créer un compte gratuit</a>
          <ul class="plan-feats">
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>+ 12 000 chants</strong> · paroles, accords, traductions</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Recherche par recueil, langue, BPM, tonalité</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Playlists illimitées, favoris, historique</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Lecture en streaming · <strong>jusqu'à 192 kbps</strong></span>
            </li>
            <li class="dis">
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
              Téléchargements offline
            </li>
            <li class="dis">
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg></span>
              Annonces toutes les 3 lectures
            </li>
          </ul>
        </div>

        <!-- PREMIUM -->
        <div class="plan featured">
          <div class="plan-tier">Plan le plus choisi</div>
          <div class="plan-name">Premium</div>
          <div class="plan-tagline">Pour les fidèles, musiciens et chefs de chœur — tous les outils, sans pub.</div>
          <div class="plan-price">
            <span class="cur">$</span>
            @if (billingPeriod() === 'month') {
              <span class="amt">4,99</span>
            } @else {
              <span class="amt">49</span>
            }
            <span class="per">{{ billingPeriod() === 'month' ? '/ mois' : '/ an' }}</span>
          </div>
          <div class="plan-price-sub">
            @if (billingPeriod() === 'month') {
              Facturé chaque mois · annulable à tout moment
            } @else {
              Facturé annuellement · soit 4,08 $ / mois
            }
          </div>
          <a class="btn btn-blue plan-btn" href="/auth/register?plan=premium">Démarrer 14 jours gratuits</a>
          <ul class="plan-feats">
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>Tout le gratuit</strong>, et en plus :</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>Téléchargements offline</strong> illimités</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Qualité <strong>FLAC sans perte</strong> · 1411 kbps</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>Aucune publicité</strong>, jamais</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Mode projection HD · télécommande</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Partitions PDF · export ChordPro</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Support prioritaire (sous 24 h)</span>
            </li>
          </ul>
        </div>

        <!-- PAROISSE -->
        <div class="plan">
          <div class="plan-tier">Pour les églises</div>
          <div class="plan-name">Paroisse</div>
          <div class="plan-tagline">Une licence pour toute l'équipe — pasteur, musiciens, vidéoprojecteur du dimanche.</div>
          <div class="plan-price">
            <span class="cur">$</span>
            @if (billingPeriod() === 'month') {
              <span class="amt">19</span>
            } @else {
              <span class="amt">190</span>
            }
            <span class="per">{{ billingPeriod() === 'month' ? '/ mois' : '/ an' }}</span>
          </div>
          <div class="plan-price-sub">
            @if (billingPeriod() === 'month') {
              Jusqu'à 10 utilisateurs · facturation unique
            } @else {
              Jusqu'à 10 utilisateurs · soit 15,83 $ / mois
            }
          </div>
          <a class="btn btn-ghost plan-btn" href="#contact">Demander une démo</a>
          <ul class="plan-feats">
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>Tout Premium</strong>, pour <strong>10 utilisateurs</strong></span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span><strong>Licence projection</strong> claire pour l'église</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Outil <strong>Liturgie</strong> · prépare un service complet</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Bibliothèque partagée entre l'équipe</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Facturation unifiée · facture officielle</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Onboarding personnalisé pour l'équipe</span>
            </li>
            <li>
              <span class="tick"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span>
              <span>Support dédié <strong>en moins d'une heure</strong></span>
            </li>
          </ul>
        </div>

      </div>

      <div class="plans-foot">
        <span class="pf-ic">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
        </span>
        <div class="pf-body">
          <strong>Étudiant ou pasteur en stage&nbsp;?</strong> Le plan Premium est gratuit pour toi pendant 12 mois.
          <a class="btn-link" href="#" style="margin-left:6px;">Justifier mon statut →</a>
        </div>
      </div>
    </div>
  </section>

  <!-- ==================== COMPARISON TABLE ==================== -->
  <section class="compare" id="compare">
    <div class="shell">
      <div class="section-eyebrow">Comparaison détaillée</div>
      <h2 class="section-h">Tout, ligne par ligne.</h2>
      <p class="section-lede">Pour les chefs de chœur et les trésoriers d'église qui aiment voir le tableau complet avant de décider.</p>

      <table class="compare-table">
        <thead>
          <tr>
            <th class="feat-col">Fonctionnalité</th>
            <th><span class="ti">Gratuit</span><span class="price">0 $ / mois</span></th>
            <th class="col-featured"><span class="ti">Premium</span><span class="price">4,99 $ / mois</span></th>
            <th><span class="ti">Paroisse</span><span class="price">19 $ / mois · 10 user.</span></th>
          </tr>
        </thead>
        <tbody>
          <tr class="group-h"><td colspan="4">Bibliothèque & lecture</td></tr>
          <tr>
            <td class="feat"><div class="lbl">Accès aux + de 12 000 chants</div><div class="desc">Paroles, accords, traductions, audio quand disponible</div></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Qualité audio max</div><div class="desc">Pour casque audio et hi-fi</div></td>
            <td><span class="val">192 kbps</span></td>
            <td><span class="val">FLAC · 1411 kbps</span></td>
            <td><span class="val">FLAC · 1411 kbps</span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Téléchargements offline</div><div class="desc">Pour les services sans wifi</div></td>
            <td><span class="no">—</span></td>
            <td><span class="val">Illimités</span></td>
            <td><span class="val">Illimités</span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Publicité</div></td>
            <td><span class="val ember">1 / 3 lectures</span></td>
            <td><span class="val success">Aucune</span></td>
            <td><span class="val success">Aucune</span></td>
          </tr>

          <tr class="group-h"><td colspan="4">Projection & scène</td></tr>
          <tr>
            <td class="feat"><div class="lbl">Mode karaoké</div><div class="desc">Plein écran, auto-scroll, taille XL</div></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Mode projection HD</div><div class="desc">Multi-écran, télécommande mobile</div></td>
            <td><span class="no">—</span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Licence projection légale</div><div class="desc">Pour ton vidéoprojecteur d'église</div></td>
            <td><span class="no">—</span></td>
            <td><span class="val">Personnelle</span></td>
            <td><span class="val blue">Collective</span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Outil Liturgie</div><div class="desc">Préparer un service dominical, export PDF</div></td>
            <td><span class="no">—</span></td>
            <td><span class="no">—</span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>

          <tr class="group-h"><td colspan="4">Équipe & comptes</td></tr>
          <tr>
            <td class="feat"><div class="lbl">Utilisateurs inclus</div><div class="desc">Chacun garde ses playlists et préférences</div></td>
            <td><span class="val">1</span></td>
            <td><span class="val">1</span></td>
            <td><span class="val blue">Jusqu'à 10</span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Bibliothèque partagée</div><div class="desc">Playlists communes pour le groupe de louange</div></td>
            <td><span class="no">—</span></td>
            <td><span class="no">—</span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Facturation unique · facture officielle</div></td>
            <td><span class="no">—</span></td>
            <td><span class="val">Reçu personnel</span></td>
            <td><span class="val blue">Facture organisation</span></td>
          </tr>

          <tr class="group-h"><td colspan="4">Support & communauté</td></tr>
          <tr>
            <td class="feat"><div class="lbl">Support</div></td>
            <td><span class="val">Centre d'aide</span></td>
            <td><span class="val">Prioritaire · 24 h</span></td>
            <td><span class="val blue">Dédié · &lt; 1 h</span></td>
          </tr>
          <tr>
            <td class="feat"><div class="lbl">Vote sur les nouvelles fonctionnalités</div><div class="desc">Tu nous dis quoi construire ensuite</div></td>
            <td><span class="no">—</span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
            <td><span class="yes"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></span></td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <!-- ==================== TESTIMONIALS ==================== -->
  <section class="testimonials">
    <div class="shell">
      <div class="section-eyebrow">Ce qu'en disent les gens</div>
      <h2 class="section-h">De Port-au-Prince à Montréal,<br/>l'église chante encore.</h2>
      <p class="section-lede">Trois témoignages, parmi des centaines reçus depuis le lancement de Premium.</p>

      <div class="testimonials-grid">
        @for (t of testimonials; track t.initials) {
          <article class="testimonial">
            <div class="quote-mark">"</div>
            <p>{{ t.text }}</p>
            <div class="testimonial-by">
              <span class="av" [style.background]="t.avatarBg">{{ t.initials }}</span>
              <div class="body">
                <div class="nm">{{ t.name }}</div>
                <div class="role">{{ t.role }}</div>
              </div>
              <span class="plan-pill" [class.paroisse]="t.plan === 'paroisse'" [class.premium]="t.plan === 'premium'">{{ t.plan === 'premium' ? 'Premium' : 'Paroisse' }}</span>
            </div>
          </article>
        }
      </div>
    </div>
  </section>

  <!-- ==================== FAQ ==================== -->
  <section class="faq">
    <div class="shell">
      <div class="faq-grid">
        <div class="faq-left">
          <div class="section-eyebrow">Questions fréquentes</div>
          <h2 class="section-h" style="font-size:clamp(24px,3vw,36px);">Tout ce que tu te poses.</h2>
          <p>Pas trouvé ? Écris-nous à <a href="mailto:hello@lyricstream.app">hello&#64;lyricstream.app</a> — on répond sous 24 h.</p>
          <a class="btn btn-ghost" href="#">Centre d'aide complet</a>
        </div>

        <div class="faq-list">
          @for (faq of faqs; track faq.q; let i = $index) {
            <details class="faq-item" [open]="openFaq() === i">
              <summary class="faq-q" (click)="toggleFaq(i)">
                {{ faq.q }}
                <span class="faq-ic">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                </span>
              </summary>
              <div class="faq-a">{{ faq.a }}</div>
            </details>
          }
        </div>
      </div>
    </div>
  </section>

  <!-- ==================== FINAL CTA ==================== -->
  <section class="cta-final">
    <div class="cta-final-inner">
      <div class="ls-eyebrow">Et voilà.</div>
      <h2>Tu chantes,<br/>on s'occupe du reste.</h2>
      <p>Démarre tes 14 jours gratuits dès aujourd'hui.</p>
      <div class="cta-row">
        <a class="btn btn-primary btn-lg" href="/auth/register?plan=premium">Commencer Premium gratuitement</a>
        <a class="btn btn-ghost btn-lg" href="#contact">Parler à un humain</a>
      </div>
    </div>
  </section>

</div>
